<template>
  <MainSiteLayout v-bind="{ content }">
    <HeroWithTextOnly v-if="content.hero" :breadcrumbs="breadcrumbs" :content="content.hero" />
    <Container v-if="content.leaders" tagName="section" class="LeadershipGrid">
      <LeaderCard v-for="leader in content.leaders" :key="leader._key" :leader="leader" />
    </Container>
    <Container v-if="content.cta" tagName="section" class="LeadershipCta">
      <CtaLink v-bind="content.cta" />
    </Container>
    <FooterCta v-if="content.footerCta" :content="content.footerCta" />
  </MainSiteLayout>
</template>

<script>
export const contentQuery = `
  *[_id == $pageId][0]{
    locale,
    hero,
    introText,
    leaders,
    cta,
    footerCta,
  }
`
</script>

<script setup>
import { provide } from 'vue'

import MainSiteLayout from '../../layouts/MainSiteLayout.vue'
import FooterCta from '../../shared/FooterCta.vue'
import HeroWithTextOnly from '../headerFooterSections/HeroWithTextOnly.vue'
import LeaderCard from './LeaderCard.vue'

const { breadcrumbs, content } = defineProps({
  breadcrumbs: Array,
  content: Object,
})

provide('locale', content.locale)
</script>

<style scoped>
.LeadershipGrid {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: var(--spacing-14) var(--spacing-14);
  padding-top: var(--spacing-15);
  padding-bottom: var(--spacing-15);
  color: var(--text-color-dark);
}

.LeadershipCta {
  padding-bottom: var(--spacing-15);
  color: var(--text-color-dark);
}

@media (--screen-lg) {
  .LeadershipGrid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .leaderModal .modalPane  {
    margin: var(--spacing-10) auto;
    border-radius: var(--border-radius);
  }
}
</style>
